import Image from 'next/image'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { useCurrentChainId, useIsValidWETHNetwork } from '~/hooks'
import { getChainById } from '~/utils/chain'

export const Network: React.FC = () => {
  const { t } = useTranslation()
  const chainId = useCurrentChainId()
  const isValidNetwork = useIsValidWETHNetwork()

  const network = getChainById(chainId)

  if (!isValidNetwork) {
    return <span>{t('unsupported_network')}</span>
  }

  return (
    <StyledNetworkIndicator>
      <Image src={network.logoUrl} width="18" height="18" alt="network logo" />
      <span>{network.chainName}</span>
    </StyledNetworkIndicator>
  )
}

const StyledNetworkIndicator = styled.div`
  display: inline-flex;
  align-items: center;

  span {
    margin-left: 4px;
  }
`
